import PostsManagerPage from "./pages/PostsManagerPage.tsx"
import { Layout } from "widgets/layouts"

export default function App() {
  return (
    <Layout>
      <PostsManagerPage />
    </Layout>
  )
}
